import React, {useState, useEffect, useCallback} from 'react';
import './styles.css';
import '../../assets/styles/styles.css';
import {useDispatch} from 'react-redux';
import {useSelector} from 'react-redux';
import Footer from '../../components/footer/footer';
import {useHistory} from "react-router-dom";
import ImageViewer from 'react-simple-image-viewer';

function Gallery(){

    const history = useHistory();
    const dispatch = useDispatch();
    const region = useSelector(state => state.initiative.regionClicked);
    const images = [
        'http://placeimg.com/1200/800/nature',
        'http://placeimg.com/800/1200/nature',
        'http://placeimg.com/1920/1080/nature',
        'http://placeimg.com/1500/500/nature',
        'http://placeimg.com/1920/1080/nature',
        'http://placeimg.com/1500/500/nature',
        'http://placeimg.com/1920/1080/nature',
        'http://placeimg.com/1500/500/nature',
        'http://placeimg.com/1920/1080/nature',
        'http://placeimg.com/1500/500/nature',
    ];
    const [currentImage, setCurrentImage] = useState(0);
    const [isViewerOpen, setIsViewerOpen] = useState(false);  
    const openImageViewer = useCallback((index) => {
        setCurrentImage(index);
        setIsViewerOpen(true);
    }, []);
     
    const closeImageViewer = () => {
        setCurrentImage(0);
        setIsViewerOpen(false);
    };
   
    return (
        <React.Fragment>
            {
                isViewerOpen && (
                    <ImageViewer src={images} currentIndex={currentImage} onClose={closeImageViewer}/>
                )
            }
            <div className="p-2">
                <div className="bt-1" onClick={() => history.goBack()}>Regresar</div>
                <div className="row m-0 justify-content-center mt-3">
                <div className="col-12 p-0">
                    <div style={{fontWeight:"bold", fontSize:30}}>Fotos</div>
                    <div className="row m-0 justify-content-center">
                        {
                            images.map((src, index) => (
                                <div className="gal" key={index}>
                                    <img src={src} onClick={() => openImageViewer(index)} key={index} style={{width:"100%", height:"100%", objectFit:"cover"}} alt=""/>
                                </div>
                            ))
                        }
                    </div>
                    <div style={{fontWeight:"bold", fontSize:30}}>Audios</div>
                    <audio controls>
                    </audio>
                    </div>
                </div>
            </div>
            <Footer/>
        </React.Fragment>
    )
}

export default Gallery;